import clsx from 'clsx'
import { FC } from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { setLanguage, useLang } from '../../../_metronic/i18n/Metronici18n'
import { FormattedMessage } from 'react-intl'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'react-bootstrap'
import '../../../_metronic/assets/css/custom-languages-login.css'

const languages = [
  {
    lang: 'en',
    name: <FormattedMessage id="LANGUAGE.ENGLISH" defaultMessage="English" />,
    flag: toAbsoluteUrl('media/flags/united-states.svg'),
  },
  {
    lang: 'de',
    name: <FormattedMessage id="LANGUAGE.GERMAN" defaultMessage="German" />,
    flag: toAbsoluteUrl('media/flags/germany.svg'),
  },
  {
    lang: 'fr',
    name: <FormattedMessage id="LANGUAGE.FRENCH" defaultMessage="French" />,
    flag: toAbsoluteUrl('media/flags/france.svg'),
  },
  {
    lang: 'it',
    name: <FormattedMessage id="LANGUAGE.ITALIAN" defaultMessage="Italian" />,
    flag: toAbsoluteUrl('media/flags/italy.svg'),
  },
]

const LanguagesLogin: FC = () => {
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)

  return (
    <Dropdown className='px-8'>
      <DropdownToggle className='btn btn-icon bg-body' id='dropdown-language'>
        <img
          className='w-20px h-20px rounded me-3'
          src={currentLanguage?.flag}
          alt={currentLanguage?.lang}
        />
        <span className='text-primary'>{currentLanguage?.name}</span>
      </DropdownToggle>

      <DropdownMenu className='w-175px py-4 bg-body' aria-labelledby='dropdown-language'>
        {languages.map((l) => (
          <DropdownItem
            key={l.lang}
            className={clsx('d-flex align-items-center px-5 no-hover')}
            onClick={() => setLanguage(l.lang)}
          >
            <img className='w-20px h-20px rounded me-2' src={l.flag} alt={l.lang} />
            <span>{l.name}</span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}

export { LanguagesLogin }

